const $ = require('jquery');

// Bind change event to the specific select list of Pest Library Categories.
$('#pest-library-categories').on('change', function () {
  // Get the URL and redirect if valid.
  var url = $(this).val();
  if (url) {
    window.location = url;
  }
  return false;
});
